// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"2238cf34","422":"6e7c02e1","679":"75ec48e8","845":"19a87ef5","869":"deabd1d4"}[chunkId] + ".chunk.js";
};